export function useKebabcase(text: string | undefined) {
  return text
    ?.split(/(?=[A-Z])/)
    ?.join('-')
    ?.toLowerCase()
}
